// The Notice Type window — opened by the "+" on the parcel card's Proposed Notice. Lists the ACTIVE notice types
// (notice_types, Utilities → Table Management) in their set order; Add stays greyed until one is picked (step 6).
import React, { useState } from 'react';
import { backdropProps } from '../utils/backdropClose';

export default function NoticeTypePicker({ types, onAdd, onCancel, s, c }) {
  const [picked, setPicked] = useState('');
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 10002, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      {...backdropProps(onCancel)}>
      <div style={{ background: c.card, border: `1px solid ${c.border}`, borderRadius: '12px', boxShadow: '0 12px 40px rgba(0,0,0,0.4)', padding: '20px 22px', width: '320px', maxWidth: '90vw' }}>
        <div style={{ fontSize: '15px', fontWeight: '700', color: c.text, marginBottom: '4px' }}>Notice Type</div>
        <div style={{ fontSize: '13px', color: c.subtext, marginBottom: '14px' }}>Select a notice to continue</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '18px' }}>
          {types.map(t => (
            <label key={t.key} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: c.text, cursor: 'pointer' }}>
              <input type="radio" name="notice-type" value={t.key} checked={picked === t.key} onChange={() => setPicked(t.key)} />
              {t.name}
            </label>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <button type="button" onClick={onCancel} style={s.btnGhost}>Cancel</button>
          <button type="button" onClick={() => onAdd(picked)} disabled={!picked} style={{ ...s.btn, opacity: picked ? 1 : 0.5 }}>Add</button>
        </div>
      </div>
    </div>
  );
}
